var render = function render(){var _vm=this,_c=_vm._self._c;return _c('draggable-box',{attrs:{"stopPosition":_vm.stopPosition,"initX":_vm.initX,"initY":_vm.initY}},[_c('span',{class:[_vm.startScroll ? 'hide' : 'animate__backInRight']},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }